// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__ok9p3","spinner":"Spinner_spinner__R6Zmz","spin":"Spinner_spin__R3gi0","text":"Spinner_text__x7PTq"};